import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    frame: String,
    url: String,
    delay: { type: Number, default: 1000 }
  }

  schedule() {
    window.setTimeout(() => {
      this.refreshViaTurboStream()
    }, this.delayValue)
  }

  async refreshViaTurboStream() {
    if (!this.urlValue || !window.Turbo?.renderStreamMessage) {
      this.refreshFrameFallback()
      return
    }

    try {
      const currentParams = new URLSearchParams(window.location.search)
      const refreshUrl = new URL(this.urlValue, window.location.origin)
      currentParams.forEach((value, key) => refreshUrl.searchParams.append(key, value))

      const response = await window.fetch(refreshUrl.toString(), {
        method: "GET",
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin"
      })

      if (!response.ok) {
        this.refreshFrameFallback()
        return
      }

      const turboStreamHtml = await response.text()
      window.Turbo.renderStreamMessage(turboStreamHtml)
    } catch (error) {
      this.refreshFrameFallback()
    }
  }

  refreshFrameFallback() {
    if (!this.frameValue || !window.Turbo?.visit) return

    const url = `${window.location.pathname}${window.location.search}`
    window.Turbo.visit(url, { frame: this.frameValue })
  }
}
